<template>
  <div v-if="visivel" class="w3-modal" style="display: block">
    <div class="w3-container w3-modal-content w3-animate-zoom">

      <header class="w3-row-padding">
        <span @click="fechar" class="w3-button w3-display-topright">&times;</span>
        <h4 class="texto-vermelho">Pesquisa de Cadastros</h4>
      </header>

      <div
        v-show="mostrar_filtros"
        class="w3-row-padding w3-margin-bottom">

        <div
          class="w3-left w3-padding-left w3-col"
          style="padding: 0;">

          <div
            class="w3-dropdown-hover w3-transparent w3-left w3-col s2 m1"
            style="margin-top: 21px; padding: 4px 0">

            <button class="w3-button texto-vermelho w3-border">
              <i class="fa fa-cog"></i>
            </button>

            <div
              class="w3-dropdown-content w3-bar-block w3-border"
              style="width: 210px;">

              <div
                :key="tipo_pesquisa.indice_tela"
                v-for="tipo_pesquisa in tipos_pesquisa">
                
                <button 
                  class="w3-bar-item w3-button botao-quadrado" 
                  @click="indice_pesquisa = tipo_pesquisa.indice_tela">
                    <i :class="getIconeFiltro(tipo_pesquisa.indice_tela)"></i>
                    {{tipo_pesquisa.descricao_pesquisa}}
                </button>
              </div>
            </div>
          </div>

          <div class="w3-col s10 m8 l9 w3-padding-small">
            <strong for="campoPesquisa">
              <span>{{tipos_pesquisa[indice_pesquisa].descricao_pesquisa}}</span>
            </strong>

            <input 
              type="text"
              class="w3-input w3-border" 
              style="max-width: 98%; border-radius:4px" 
              v-model="chave_pesquisa"
              id="campoPesquisa"
              autocomplete="off"
              :placeholder="tipos_pesquisa[indice_pesquisa].placeholder"
              v-on:keyup="converterMaiusculo()"
              v-on:keyup.enter="buscar()"
              ref="campoPesquisa">
          </div>

          <div class="w3-col m3 l2" style="padding:4px 0"> 
            <button 
              class="w3-button w3-theme w3-right w3-col" 
              style="margin-top: 21px;"
              v-on:click="buscar()"
              :disabled="processando">
                <span>Pesquisar</span>
              </button>                  
          </div>
        </div>
      </div>

      <div class="w3-col s12 m12 l12" v-if="processando">
        <div class="w3-panel w3-theme w3-card-2">
          <p>
            <i class="fa fa-sync-alt w3-spin"></i>
            <span> Processando...</span>
          </p>
        </div>
      </div>

      <div
        v-if="(
          (dados_filtrados.length > 0) &&
          (!processando) &&
          (mostrar_filtros)
        )"
        class="w3-col s12 m12 s12 w3-center"
        style="margin-top: 1px;">

        <i
          class="fas fa-caret-down"
          @click="mostrar_filtros = false"
          style='font-size:24px; cursor: pointer;'>
        </i>
      </div>

      <div class="w3-col s12 m12 l12 w3-left">
        <button
          class="w3-bar-item w3-button w3-col w3-white w3-border w3-mobile"
          v-if="!mostrar_filtros"
          v-on:click="mostrar_filtros = !mostrar_filtros">
          <i class="fa fa-filter icone-vermelho"></i>
          <span> Mostrar filtros</span>
        </button>
      </div>             

      <div v-if="!mostrar_filtros">
        <div class="w3-col s12 w3-margin-top w3-margin-bottom">
          <div
            v-show="dados_filtrados.length > 0"
            class="w3-responsive w3-border"
            v-if="!mostrar_filtros"
            style="max-height: calc(75vh - 300px); min-height: 200px; overflow: auto">

            <div
              class="w3-margin-bottom"
              :key="cadastro.cadastro_id"
              v-for="cadastro in dados_filtrados"
              @click="confirmar(cadastro)">

              <div class="w3-col fundo-enfase">
                <strong>{{cadastro.cadastro_id}} - {{cadastro.nome_razao_social}}</strong>
              </div>

              <small>
                <div class="w3-col s12 fundo-enfase-2">
                  <label v-if="cadastro.cpf_cnpj">CPF/CNPJ: </label>
                  <strong class="sem-quebra">{{cadastro.cpf_cnpj}}</strong>
                </div>

                <div class="w3-col s12 fundo-enfase-2">
                  <label v-if="cadastro.data_nascimento">Data de nascimento:</label>
                  <strong class="sem-quebra">{{cadastro.data_nascimento}}</strong>
                </div>

                <div class="w3-col s12 fundo-enfase-2">
                  <label>Endereço:</label>
                  <strong>{{
                    getEndereco(
                      cadastro.logradouro,
                      cadastro.complemento,
                      cadastro.nome_bairro,
                      cadastro.nome_cidade
                    )}}</strong>
                </div>
              </small>
            </div>

          </div>
        </div>
      </div>

      <footer class="w3-container conteudo-centralizado"></footer>
    </div>
  </div>

</template>

<script>
  import toastr from 'toastr';
  import RPesquisaCadastros from '@/components/Rest/RPesquisaCadastros';
  import RCadastro from '@/components/Rest/RCadastro';


  export default {
    name: 'PesquisaCadastros',

    props: {
      pesquisaPadrao: {
        required: true,
        type: String,
        default: 'NOM'
      }
    },

    data() {
      return {
        visivel: false,

        tipos_pesquisa: [
          {
            indice_tela: 0,
            tipo: 'NOM',
            descricao_pesquisa: 'Nome / razão social',
            placeholder: 'Digite o nome ou razão social'
          },

          {
            indice_tela: 1,
            tipo: 'FAN',
            descricao_pesquisa: 'Nome fantasia',
            placeholder: 'Digite o nome fantasia'
          },

          {
            indice_tela: 2,
            tipo: 'CPF',
            descricao_pesquisa: 'CPF/CNPJ',
            placeholder: 'Digite o CPF/CNPJ (apenas números)'
          },

          {
            indice_tela: 3,
            tipo: 'INE',
            descricao_pesquisa: 'Inscrição estadual',
            placeholder: 'Digite a inscrição estadual (apenas números)'
          }
        ],

        indice_pesquisa: 2,
        mostrar_filtros: true,
        dados_filtrados: [],
        chave_pesquisa: '',
        processando: false
      };
    },

    methods: {
      abrir() {
        this.limparTela();
        this.visivel = true;
        this.$nextTick(() => this.$refs.campoPesquisa.focus());
      },

      fechar() {
        this.visivel = false;
      },

      confirmar(cadastro) {
        this.$emit('confirmar', cadastro);
        this.visivel = false;
      },

      limparTela() {
        this.mostrar_filtros = true;
        this.dados_filtrados = [];
        this.chave_pesquisa = '';
        this.processando = false;

        this.indice_pesquisa = 2;
        for (let i = 0; i < this.tipos_pesquisa.length; i++) {
          if (this.tipos_pesquisa[i].tipo == this.pesquisaPadrao) {
            this.indice_pesquisa = i;
            break;
          }
        }
      },

      getIconeFiltro(indice) {
        if(indice == this.indice_pesquisa) {
          return 'fa fa-check-square icone-vermelho';
        }
        else {
          return 'far fa-square';
        }
      },
      converterMaiusculo() {
        this.chave_pesquisa = this.chave_pesquisa.toUpperCase();
      },

      async buscar() {
        try {
          this.processando = true;
          this.dados_filtrados = [];

          let parametros = {
            tipo_pesquisa: this.tipos_pesquisa[this.indice_pesquisa].tipo,
            chave: this.chave_pesquisa
          }

          let resposta = await RCadastro.pesquisarCadastros(this.axios, parametros);
          if (resposta.houve_erro != 'N') {
            throw new Error(resposta.mensagem);
          }
        
          this.dados_filtrados = JSON.parse(JSON.stringify(resposta.dados));
          this.chave_pesquisa = '';
          this.mostrar_filtros = false;
          this.processando = false
        }
        catch (e) {
          this.processando = false;
          toastr.error(e.message);
        }
      },

      getEndereco(logradouro, complemento, nome_bairro, nome_cidade) {
        let retorno = '';

        if (logradouro) {
          retorno = '' + logradouro;
        }
        
        if (logradouro && complemento) {
          retorno += ',';
        }
        
        if (complemento) {
          retorno += ' ' + complemento;
        }

        if (retorno.trim() != '') {
          retorno += ' -';
        }

        retorno += ' ' + nome_bairro + ' - ' + nome_cidade;

        return retorno;
      }
    }
  };
</script>

<style escoped>
  @media screen and (min-width: 1200px) {
    .w3-modal-content {
      width: 80%;
    }
  }

  @media screen and (max-width: 1199px) {
    .w3-modal-content {
      width: 95%;
    }
  }

  .sem-quebra {
    white-space: nowrap;
  }

  .fundo-enfase {
    background-color: #dedede;
  }

  .fundo-enfase-2 {
    background-color: #eeeeee;
  }

</style>





// WEBPACK FOOTER //
// src/components/Pesquisas/PesquisaCadastros.vue